export const exampleCSVdata = [
    {
        "address": "cd1e6623-8dc6-42b0-88ad-392943be0733",
        "balance": "50000",
        "externalCustomerId": "C0000002"
    },

]

export const csvHeaders = [
    { label: "CustomerId", key: "CustomerId" },
    { label: "Amount", key: "amount" },
    { label: "ExternalId", key: "ExternalId" }
]